var React = require('react');

function Play (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","d":"M8.21 5.113l10.318 6.078c.466.275.612.86.325 1.307a.972.972 0 0 1-.325.311L8.21 18.887a.815.815 0 0 1-1.092-.249A.736.736 0 0 1 7 18.24V5.76c0-.42.355-.76.794-.76a.82.82 0 0 1 .416.113z"}));
}

Play.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Play;

Play.default = Play;
